// extracted by css-extract-rspack-plugin
var _1 = "ErrorPanel-m_errorCode-wj2HXLSm";
var _2 = "ErrorPanel-m_errorPanel-uOyNdy1U";
var _3 = "ErrorPanel-m_links-p8R0ha5_ common-m_flexRow-ZPndn63a";
var _4 = "ErrorPanel-m_socials-ysnf6hAY";
var _5 = "ErrorPanel-m_timeline-ZIl8kQaj";
export { _1 as "errorCode", _2 as "errorPanel", _3 as "links", _4 as "socials", _5 as "timeline" }
